import React from "react";
import { capitalized1LetterS, uniqueId } from "../../utils/generalLiveCenter";

const MatchStats = ({ stats }) => {
  return (
    <ul className="stats_list">
      {stats?.map((s, i) => {
        const isPercentage = s?.type === "possession_percentage";
        return (
          <li
            key={uniqueId(i)}
            style={{ display: s?.type === "total" ? "none" : undefined }}
          >
            <div className="bar_status_top">
              <strong className="stats_num">
                {s?.ht}
                {isPercentage ? "%" : ""}
              </strong>
              <span className="bar_status">{capitalized1LetterS(s?.type)}</span>
              <strong className="stats_num">
                {s?.at}
                {isPercentage ? "%" : ""}
              </strong>
            </div>
            <div className="bar-wrap">
              <div className="l_bar">
                <div className="stats_bar">
                  <span
                    className={`bar_color ${s?.ht > s?.at ? "higher_bar_color" : "lower_bar_color"}`}
                    style={{ width: `${s?.htPercent}%` }}
                  />
                </div>
              </div>
              <div className="r_bar">
                <div className="stats_bar">
                  <span
                    className={`bar_color ${s?.at > s?.ht ? "higher_bar_color" : "lower_bar_color"}`}
                    style={{ width: `${s?.atPercent}%` }}
                  />
                </div>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default MatchStats;
